import React, { createElement, useCallback } from 'react';
import { setFontSize } from 'roosterjs-editor-api';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../../types';
import { Dropdown, IDropdownItemRenderProps, IDropdownOption } from '../../../dropdown';
import { useFormatState, useToolbarActionContext } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';
import { selectThemeSemantics } from '../../../../styling';

const OPTIONS: IDropdownOption[] = [
    {
        key: '8pt',
        text: '8'
    },
    {
        key: '9pt',
        text: '9'
    },
    {
        key: '10pt',
        text: '10'
    },
    {
        key: '11pt',
        text: '11'
    },
    {
        key: '12pt',
        text: '12'
    },
    {
        key: '14pt',
        text: '14'
    },
    {
        key: '16pt',
        text: '16'
    },
    {
        key: '18pt',
        text: '18'
    },
    {
        key: '20pt',
        text: '20'
    },
    {
        key: '22pt',
        text: '22'
    },
    {
        key: '24pt',
        text: '24'
    },
    {
        key: '26pt',
        text: '26'
    },
    {
        key: '28pt',
        text: '28'
    },
    {
        key: '36pt',
        text: '36'
    },
    {
        key: '48pt',
        text: '48'
    },
    {
        key: '72pt',
        text: '72'
    }
];

function ItemBase(props: IDropdownItemRenderProps & IBaseComponentProps) {
    const { className, renderDefault } = props;
    return (
        <div className={className}>
            {renderDefault()}
        </div>
    );
}

const Item = styled(ItemBase)`
    height: 100%;
`;

const StyledDropdown = styled(Dropdown)`
    height: 25px;
    width: 80px;
    min-width: 40px;

    .ap-dropdown-value {
        font-size: ${selectThemeSemantics(({ baseFont: { fontSize } }) => fontSize)};
    }
`;

const onRenderItem = (props: IDropdownItemRenderProps) => createElement(Item, props);

function FontSizeActionBase(props: IEditorToolbarActionBaseProps) {
    const { editor } = useToolbarActionContext();
    const { fontSize: defaultFontSize } = editor.getDefaultFormat();
    const { fontSize = defaultFontSize } = useFormatState();

    const _onChange = useCallback(([selectedKey]: React.Key[]) => {
        setFontSize(editor, selectedKey as string);
        editor.triggerContentChangedEvent();
    }, [editor]);

    const onRenderCommand = useCallback(() => (
        <StyledDropdown items={OPTIONS} disableRefocusTarget selectedKeys={fontSize} showSearchBox={false} onRenderItem={onRenderItem} onValueChange={_onChange} />
    ), [_onChange, fontSize]);

    return (
        <CommandButton {...props} tooltip="Font Family" iconName="ap-font-size.rte" onRender={onRenderCommand} />
    );
}

export const FontSizeAction = styled(FontSizeActionBase)`
    padding: 0 8px;
`;
